<template>
  <div class='condition-curved' v-if="!this.isUSTWall">
    <div class="curved_container">
      <div v-if="searchTabActive === 'CurvedSurface'">
        <!-- 垂直 水平 -->
        <div class='curved_angle'>
          <div class="span_container">
            <span>{{$t('T_CURVE_SHAPE_TEXT')}}</span>
          </div>
          <div class="select_container">
            <el-select v-model='direction_input'>
              <el-option v-for='item in direction' :key='item.value' :label='$t(item.label)' :value='item.value'>
              </el-option>
            </el-select>
          </div>
          <div class="clear"></div>
        </div>

        <div class="img-container">
          <div class="curved-img">
            <el-image :src="imgUrl" fit="fit"></el-image>
          </div>
          <!-- 中心角 弧度 深度 -->
          <div class='curved_select_container'>
            <div class="curved_select">
              <el-select v-model="curveSelect">
                <el-option v-for="item in curveSelectOptions" :key='item.value' :label='$t(item.label)'
                  :value='item.value'>
                </el-option>
              </el-select>
            </div>
            <div class="select_span_container ellipsis">
              <!-- 中心角 -->
              <div v-if="curveSelect === '0'">
                <el-input v-model='central_angle_input' class='roomsize_input'
                  @input="testDigital($event, 'central_angle_input')" @blur='onCentralAngleChange(central_angle_input)'
                  @keyup.enter.native="onCentralAngleChange(central_angle_input)">
                </el-input>
                <span class='m'>{{$t('T_CURVE_DEGREE')}}</span>
              </div>
              <!-- 弧长 -->
              <div v-if="curveSelect === '1'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="arc_input" :unitData="unit" @blur='changeMutation("arc_input", "", true)'></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='arc_input' :rules="rules.number">
                    <el-input v-model='arc_input' class='roomsize_input' @input="testDigital($event, 'arc_input')"
                      @blur='changeMutation("arc_input", "", true)'
                      @keyup.enter.native='changeMutation("arc_input", "", true)'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 深度 -->
              <div v-if="curveSelect === '2'">
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="depth_input" :unitData="unit" @blur='changeMutation("depth_input", "SET_CURVEDEPTH", true)' :forceUpdate="depthForceUpdate"></FtInput>
                </div>
                <div v-else>
                  <inputValidateBox prop='depth_input' :rules="rules.number">
                    <el-input v-model='depth_input' class='roomsize_input' @input="testDigital($event, 'depth_input')"
                      @blur='changeMutation("depth_input", "SET_CURVEDEPTH", true)'
                      @keyup.enter.native='changeMutation("depth_input", "SET_CURVEDEPTH", true)'>
                    </el-input>
                    <span class="m">{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
              <!-- 半径 -->
              <div v-if="curveSelect === '3'">
                <!-- <div class="span_unit_container">
                  <span>{{$t('T_CURVE_RADIUS')}}</span>
                </div> -->
                <div class="ft_inch_item ft_inch_item-wdith" v-if="isFraction">
                  <FtInput v-model="radius_input" :unitData="unit" @blur='changeMutation("radius_input", "SET_CURVERADIUS", true)' :forceUpdate="radiusForceUpdate"></FtInput>
                </div>
                <div class="input_unit_container" v-else>
                  <inputValidateBox prop='radius_input' :rules="rules.number">
                    <el-input v-model='radius_input' @input="testDigital($event, 'radius_input')" class='roomsize_input'
                      @blur='changeMutation("radius_input", "SET_CURVERADIUS", true)'
                      @keyup.enter.native='changeMutation("radius_input", "SET_CURVERADIUS")'>
                    </el-input>
                    <span class='m'>{{unitLabel}}</span>
                  </inputValidateBox>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- </el-collapse-item>
    </el-collapse> -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import inputValidateBox from '@/components/inputValidateBox'
import FtInput from '@/components/ftInput'

export default {
  components: {inputValidateBox, FtInput},
  name: 'curveCondition',
  props: ['angleActive', 'ambientActive'],
  data () {
    return {
      curve_activeNames: ['1'],
      direction: [
        {
          value: '0',
          label: 'T_CONCAVE'
        },
        {
          value: '1',
          label: 'T_CONVEX'
        }
      ],
      curveSelectOptions: [
        {
          value: '0',
          label: 'T_CURVE_ANGLE'
        }, {
          value: '1',
          label: 'T_CURVE_ARC'
        }, {
          value: '2',
          label: 'T_CURVE_DEPTH'
        }, {
          value: '3',
          label: 'T_CURVE_RADIUS'
        }
      ],
      curveSelect: '2',
      radius_input: '0',
      central_angle_input: 0,
      arc_input: '0',
      depth_input: '0',
      rules: {
        'number': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'}
        ],
        'numberValid': [
          // {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'},
          {pattern: /^\d+\.\d+$|\\+$|"+$/g, message: 'T_ALERT_DISPLAY_INPUT_ERROR'}
        ]
      },
      radiusForceUpdate: false,
      arcForceUpdate: false,
      depthForceUpdate: false
    }
  },
  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'isUSTWall',
      'isOutOfSpec',
      'curveShape',
      'curveDirection',
      'curveCenter',
      'curveRadius',
      'curveCentralAngle',
      'curveDepth',
      'indAngleSwitch',
      'searchTabActive'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    unit () {
      return this.graph.unit
    },
    direction_input: {
      get () {
        return this.curveDirection
      },
      set (value) {
        // this.SET_OFFSET(0)
        this.setCurveCenter(value)
        this.SET_CURVEDIRECTION(value)
      }
    },

    central_angle () { // 角度制
      return (180 * this.curveCentralAngle / Math.PI).toFixed(1)
    },
    curveArc () {
      return this.curveRadius * this.central_angle * Math.PI / 180
    },
    imgUrl () {
      let url
      // curveShape '0':垂直曲面, '1':水平曲面, '2': 平面
      // curveDirection '0':凹面, '1':凸面
      if (this.curveShape === '0' && this.curveDirection === '0') { // 凹面垂直
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'concaveVertical1_Angle.png'
            break
          case '1':
            url = 'concaveVertical1_Arc.png'
            break
          case '2':
            url = 'concaveVertical1_Depth.png'
            break
          case '3':
            url = 'concaveVertical1_Radius.png'
            break
          default:
            break
        }
      }
      if (this.curveShape === '1' && this.curveDirection === '0') { // 凹面水平
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'concaveLevel1_Angle.png'
            break
          case '1':
            url = 'concaveLevel1_Arc.png'
            break
          case '2':
            url = 'concaveLevel1_Depth.png'
            break
          case '3':
            url = 'concaveLevel1_Radius.png'
            break
          default:
            break
        }
      }
      if (this.curveShape === '0' && this.curveDirection === '1') { // 凸面垂直
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'convexVertical1_Angle.png'
            break
          case '1':
            url = 'convexVertical1_Arc.png'
            break
          case '2':
            url = 'convexVertical1_Depth.png'
            break
          case '3':
            url = 'convexVertical1_Radius.png'
            break
          default:
            break
        }
      }
      if (this.curveShape === '1' && this.curveDirection === '1') { // 凸面水平
        switch (this.curveSelect) {
          case '0':// 中心角
            url = 'convexLevel1_Angle.png'
            break
          case '1':
            url = 'convexLevel1_Arc.png'
            break
          case '2':
            url = 'convexLevel1_Depth.png'
            break
          case '3':
            url = 'convexLevel1_Radius.png'
            break
          default:
            break
        }
      }
      return require('@/assets/parts/curvedSurface/' + url)
    },
    isFraction () {
      return this.unit === 'T_FEET_FRACTION' || this.unit === 'T_INCH_FRACTION'
    }
  },
  watch: {
    angleActive (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    ambientActive (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    unit (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(this.curveRadius, newValue, false)
      this.depth_input = this.$commonJs.changeUnit(this.curveDepth, newValue, false)
      this.arc_input = this.$commonJs.changeUnit(this.curveArc, newValue, false)
    },
    houseInfo: {
      handler (newValue, oldValue) {
        if (!this.isOutOfSpec && this.curveDepth) {
          this.initCurveInfo()
        }
      },
      deep: true
    },
    curveRadius (newValue, oldValue) {
      this.radius_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false)
      this.central_angle_input = this.central_angle
    },
    curveDepth (newValue, oldValue) {
      this.depth_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },
    curveArc (newValue, oldValue) {
      this.arc_input = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    }
  },
  methods: {
    ...mapMutations([
      'SET_CURVEDIRECTION',
      'SET_CURVERADIUS',
      'SET_CURVECENTRALANGLE',
      'SET_CURVECENTER',
      'SET_CURVEDEPTH'
    ]),
    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },
    changeMutation (key, mutationKey, callBack, args = '') {
      this.radiusForceUpdate = false
      this.depthForceUpdate = false
      this.arcForceUpdate = false

      this.$nextTick(() => {
        if (!this.isFraction && (isNaN(this[key]) || this[key] === '')) this[key] = '0'
        let temp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
        if (!temp) {
          this.resetCurveValue()
          return
        }
        // this[key] = this.$commonJs.changeUnit(data, this.graph.unit, false)
        let radius
        if (key === 'radius_input') {
          let {min, max} = this.getRadiusRange()
          let data = this.$commonJs.checkRange(temp, min, max)
          this[key] = this.$commonJs.changeUnit(data, this.graph.unit, false)
          radius = data
          if (this.isFraction && data !== temp) {
            this.radiusForceUpdate = true
          }
        }
        if (key === 'depth_input') {
          let {min, max} = this.getDepthRange()
          let data = this.$commonJs.checkRange(temp, min, max)
          this[key] = this.$commonJs.changeUnit(data, this.graph.unit, false)
          radius = this.$commonJs.curveDepthToRadius(data)
          this.SET_CURVEDEPTH(data, key)
          if (this.isFraction && data !== temp) {
            this.depthForceUpdate = true
          }
        }
        if (key === 'arc_input') {
          let {min, max} = this.getArcRange()
          let data = this.$commonJs.checkRange(temp, min, max)
          this[key] = this.$commonJs.changeUnit(data, this.graph.unit, false)
          radius = this.$commonJs.curveArcToRadius(data)
          if (this.isFraction && data !== temp) {
            this.arcForceUpdate = true
          }
        }
        this.setCurveInfo(radius, key)
      })
    },
    setCurveInfo (radius, key) {
      if (key !== 'depth_input') {
        let depth = this.$commonJs.curveRadiusToDepth(radius)
        this.SET_CURVEDEPTH(depth)
      }
      let centralAngle = this.$commonJs.curveRadiusToCentralAngle(radius)
      this.SET_CURVERADIUS(radius)
      this.SET_CURVECENTRALANGLE(centralAngle)
      this.setCurveCenter(this.curveDirection)
    },
    initCurveInfo () {
      let radius
      if (this.curveShape === '1') { // 水平
        radius = [Math.pow(this.houseInfo.roomW, 2) + 4 * Math.pow(this.curveDepth, 2)] / (8 * this.curveDepth)
      } else { // 垂直
        radius = [Math.pow(this.houseInfo.roomH, 2) + 4 * Math.pow(this.curveDepth, 2)] / (8 * this.curveDepth)
      }
      this.setCurveInfo(radius)
    },
    setCurveCenter (val) {
      let curveCenter
      if (val === '1') { // 凸面
        curveCenter = this.curveDepth - this.curveRadius
      } else {
        curveCenter = this.curveRadius
      }
      this.SET_CURVECENTER(curveCenter)
    },
    onCentralAngleChange (num) {
      if (isNaN(num)) this.central_angle_input = '0'
      let value = num * 1
      if (!value) {
        this.resetCurveValue()
        return
      }
      let val = value > 180 ? 180 : value
      let angle = val * Math.PI / 180
      let radius = this.$commonJs.curveCentralAngleToRadius(angle)
      let curveDepth = this.$commonJs.curveRadiusToDepth(radius)
      this.central_angle_input = val
      this.SET_CURVEDEPTH(curveDepth)
      this.SET_CURVECENTRALANGLE(angle)
      this.SET_CURVERADIUS(radius)
      this.setCurveCenter(this.curveDirection)
    },
    resetCurveValue () {
      this.SET_CURVECENTRALANGLE(0)
      this.SET_CURVERADIUS(0)
      this.SET_CURVEDEPTH(0)
      this.SET_CURVECENTER(null)
    },
    getRadiusRange () {
      return { min: this.$commonJs.getChordLength() / 2, max: Number.POSITIVE_INFINITY }
    },
    getArcRange () {
      return { min: this.$commonJs.getChordLength() + 0.1, max: this.getRadiusRange().min * Math.PI }
    },
    getDepthRange () {
      return { min: 0, max: this.$commonJs.getChordLength() / 2 }
    }
  },
  mounted () {
    this.$emit('changeItemActive', this.curve_activeNames)
    this.central_angle_input = this.central_angle
    this.direction_input = this.curveDirection
    this.radius_input = this.$commonJs.changeUnit(this.curveRadius, this.graph.unit, false)
    this.arc_input = this.$commonJs.changeUnit(this.curveArc, this.graph.unit, false)
    this.depth_input = this.$commonJs.changeUnit(this.curveDepth, this.graph.unit, false)
  }
}
</script>
<style scoped>
  .select_container {
    float: right;
    width: 140px;
    margin-right: 34px;
  }
  .span_container {
    float: left;
    width: 148px;
  }
  .select_span_container {
    float: left;
  }
  .span_unit_container {
    float: left;
    margin-right: 10px;
  }
  .input_unit_container {
    display: flex;
    float: left;
  }
  .curved_select{
    float: left;
    width: 110px;
    margin-right: 9px;
  }
  .curved_container{
    background: #f0f0f0;
    padding: 10px 0 5px 0;
    font-size: 13px;
  }
  .img-container{
    border: 1px solid #cccccc;
    position: relative;
    background: #ffffff;
    height: 200px;
    margin: 0 10px
  }
  .curved-img{
    height: 200px;
    width: 322px;
  }
  .curved_radius{
    position: absolute;
    top: 1px;
    right: 0;
    background:#f3f3f2;
    z-index: 20
  }
  .curved_radius{
    padding: 3px 10px;
    line-height: 26px;
  }
  .curved_depth,
  .curved_angle {
    padding: 0px 10px 5px;
    line-height: 26px;
  }
  .curved_select_container{
    position: absolute;
    bottom: 0;
    left: 10px;
    line-height: 26px;
    background: #f3f3f2;
    padding: 3px 6px 1px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/condition/curveCondition.vue